import api from '../../../App/socket';

export const getGroupsList = _id => (
    api.send({
        api: 'db',
        model: 'User_group',
        action: 'Read',
        options: {
            where: { _id },
            attributes: 'all',
            include: {
                model: 'User',
                path: 'users',
            },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group/requests/get_groups_list_request.js